export default __webpack_public_path__ + "static/media/V_Banner_Vinyl.49de225a.jpg";